import { useMemo } from 'react'
import { useSelector } from 'react-redux'

const useConfiguration = () => {
    const pscState = useSelector(state => state.pscState.value)
    const config = pscState.config || {}

    const featureSharepoint = useMemo(() => {
        return config.feature_sharepoint_enabled === "1"
    }, [config.feature_sharepoint_enabled])

    const documentsInitialIssue = useMemo(() => {
        return config.documents_initial_issue || "01"
    }, [config.documents_initial_issue])

    const siteName = useMemo(() => {
        return config.site_name || "GNC"
    }, [config.site_name])
    
    return {
        config,
        featureSharepoint,
        documentsInitialIssue,
        siteName,
    }
}

export default useConfiguration
